import { ArrowDown, MessageCircle, Palette, Shield, Sparkles } from "lucide-react";
import { PHOTOS } from "@/lib/site";
import { trackEvent } from "@/lib/analytics";

const stats = [
  { value: "6", label: "Pilihan Warna" },
  { value: "3", label: "Ketebalan" },
  { value: "122 x 244", label: "Ukuran Standar" },
];

export const ProductPageHero = () => {
  return (
    <section
      id="produk-detail"
      data-testid="product-page-hero"
      className="relative min-h-[82vh] sm:min-h-screen pt-24 sm:pt-36 pb-14 sm:pb-24 bg-animax-black text-white overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={PHOTOS.produksiRak}
          alt="Animax Acrylic Sheet"
          className="w-full h-full object-cover opacity-65"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-animax-black via-animax-black/68 to-animax-black/15" />
        <div className="absolute inset-0 bg-gradient-to-t from-animax-black via-transparent to-animax-black/45" />
        <div className="absolute inset-0 bg-animax-yellow/5" />
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-6 relative">
        <div className="grid lg:grid-cols-12 gap-7 sm:gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex max-w-full items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full border border-white/20 bg-white/10 backdrop-blur-md mb-4 sm:mb-6">
              <Sparkles className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-animax-yellow" />
              <span className="tag-uppercase text-white/80">ANIMAX Acrylic</span>
            </div>
            <h1 className="font-display text-3xl sm:text-5xl lg:text-7xl leading-[1.04] tracking-tight sm:tracking-tighter font-medium">
              Acrylic Sheet untuk kebutuhan signage, display, dan proyek
            </h1>
            <p className="mt-4 sm:mt-6 text-sm sm:text-lg text-white/70 leading-relaxed max-w-2xl">
              Halaman produk dari PT APL untuk melihat katalog warna, ukuran, ketebalan, teknologi
              perlindungan UV, dan rekomendasi penggunaan ANIMAX Acrylic Sheet secara lebih detail.
            </p>

            <div className="mt-7 sm:mt-10 flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-4">
              <a
                href="#produk"
                data-testid="product-hero-catalog"
                className="inline-flex items-center justify-center gap-2 px-5 sm:px-7 py-3 sm:py-4 rounded-full bg-animax-yellow text-animax-black font-medium text-sm hover:bg-animax-orange hover:text-white transition-all"
              >
                <Palette className="w-4 h-4" />
                Lihat Katalog Warna
                <ArrowDown className="w-4 h-4" />
              </a>
              <a
                href="#tim-sales"
                data-testid="product-hero-sales"
                onClick={() =>
                  trackEvent("click_tanya_harga", {
                    category: "product",
                    label: "Acrylic Hero - Tanya Stok & Harga",
                    product_name: "Acrylic",
                  })
                }
                className="inline-flex items-center justify-center gap-2 px-5 sm:px-7 py-3 sm:py-4 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white hover:text-animax-black transition-all"
              >
                <MessageCircle className="w-4 h-4" />
                Tanya Stok & Harga
              </a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="grid grid-cols-3 gap-2 sm:gap-3">
              {stats.map((stat) => (
                <div key={stat.label} className="min-w-0 p-3 sm:p-5 rounded-xl sm:rounded-2xl border border-white/15 bg-white/10 backdrop-blur-md">
                  <div className="font-display text-lg sm:text-3xl font-medium text-animax-yellow">
                    {stat.value}
                  </div>
                  <div className="mt-1 sm:mt-2 text-[10px] sm:text-xs text-white/60 leading-snug">{stat.label}</div>
                </div>
              ))}
            </div>
            <div className="mt-3 sm:mt-4 p-4 sm:p-5 rounded-xl sm:rounded-2xl border border-white/15 bg-white/10 backdrop-blur-md flex gap-3 sm:gap-4">
              <div className="w-9 h-9 sm:w-11 sm:h-11 rounded-xl bg-animax-yellow/20 flex items-center justify-center shrink-0">
                <Shield className="w-4 h-4 sm:w-5 sm:h-5 text-animax-yellow" />
              </div>
              <div>
                <div className="font-display text-base sm:text-lg font-medium">UV Protection</div>
                <p className="mt-1 text-xs sm:text-sm text-white/60 leading-relaxed">
                  Dirancang untuk membantu menjaga kejernihan dan tampilan material saat dipakai
                  pada aplikasi indoor maupun outdoor.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
